import { SvgIcon } from '@material-ui/core'

export default function ClearIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M16.0662 8.99517C16.3591 8.70228 16.3591 8.22741 16.0662 7.93451C15.7733 7.64162 15.2985 7.64162 15.0056 7.93451L12.0004 10.9397L8.99518 7.93451C8.70229 7.64162 8.22742 7.64162 7.93452 7.93451C7.64163 8.22741 7.64163 8.70228 7.93452 8.99517L10.9397 12.0004L7.93451 15.0056C7.64162 15.2985 7.64162 15.7733 7.93451 16.0662C8.22741 16.3591 8.70228 16.3591 8.99517 16.0662L12.0004 13.061L15.0056 16.0662C15.2985 16.3591 15.7734 16.3591 16.0663 16.0662C16.3591 15.7733 16.3591 15.2985 16.0663 15.0056L13.061 12.0004L16.0662 8.99517Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
